import { ImageFieldValue, LinkField } from '@/types/sitecore';
import utils from '@/utils/index';
import { ImageField } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';

export const getFields = (item: any) => item?.fields || item || {};

export const getFieldValue = (item: any, fieldName: string, fallback = '') =>
  utils.string.ifEmpty(getFields(item)[fieldName]?.value, fallback);

export const getFieldObj = (item: any, fieldName: string) => getFields(item)[fieldName];
export const getSpText = (item: any, fieldName: string) =>
  getFieldObj(item, fieldName)?.fields?.text.value ?? '';
export const getSpVal = (item: any, fieldName: string) =>
  getFieldObj(item, fieldName)?.fields?.phrase.value ?? '';
export const isValidVideoLink = (link?: LinkField) => {
  return !(!link?.value.href || utils.obj.isNoE(link.value.href));
};
export const tryImageField = (...fields: Array<ImageField | undefined>) =>
  fields.find((x) => x?.value?.src);
export const getImageRatio = (image?: ImageFieldValue) => {
  if (!image) return undefined;
  const { width, height } = image;
  return width && height ? (width as number) / (height as number) : undefined;
};
